import { createFileRoute } from '@tanstack/react-router';

import PushMessages from '@@containers/metadata/components/Push/PushMessages';

export const Route = createFileRoute('/_authenticated/articles/$id/push')({
    component: PushMessages,
});
